import React from 'react';
import { Link } from 'react-router-dom';
import { Cog6ToothIcon, PencilIcon, PlusCircleIcon } from '@heroicons/react/24/outline';
import StatusBadge from '../../../components/ui/StatusBadge';

const chatbotUrl = (chatbotId) => `https://mydepartment.ai/coworkers/chatbot/public/${chatbotId}?iframe=true`;

/** Title, description, outside links and the Edit / Add session actions of an event. */
export default function EventDetailHeader({ event, onEdit, onDefaults }) {
  return (
    <div className="event-detail-head">
      <div className="event-detail-main">
        <div className="event-detail-kicker">
          <StatusBadge status={event?.status} />
        </div>
        <h1>{event?.title || 'Event'}</h1>
        {event?.description && <p>{event.description}</p>}
        {(event?.url || event?.chatbot_id) && (
          <p className="event-detail-links">
            {event.url && <a href={event.url} target="_blank" rel="noreferrer">Event page</a>}
            {event.chatbot_id && (
              <a href={chatbotUrl(event.chatbot_id)} target="_blank" rel="noreferrer">
                MyDepartment chatbot
              </a>
            )}
          </p>
        )}
      </div>

      <div className="event-detail-actions">
        <button type="button" className="event-detail-btn" onClick={onDefaults} disabled={!event}>
          <Cog6ToothIcon /> Report defaults
        </button>
        <button type="button" className="event-detail-btn" onClick={onEdit}>
          <PencilIcon /> Edit
        </button>
        <Link to="/upload" className="event-detail-btn event-detail-btn-primary">
          <PlusCircleIcon /> Add session
        </Link>
      </div>
    </div>
  );
}
